<template>
  <div>
    <v-dialog v-model="open" max-width="450" persistent>
      <ValidationObserver ref="observer">
        <v-card>
          <v-card-title class="headline">Alterar ordem da regra</v-card-title>
          <v-card-text>
            <header> {{selectedItemSort.description}} está na ordem {{selectedItemSort.sort}}.</header>
            Para qual ordem deseja movê-la?

            <ValidationProvider v-slot="{ errors }" name="Novo valor da ordem" rules="required">
                <v-text-field label="Novo valor da ordem" v-model="newSortValue"
                prepend-icon="mdi-order-numeric-ascending" required :error-messages="errors"></v-text-field>
            </ValidationProvider>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="cancel()">
              Cancelar
            </v-btn>
            <v-btn text @click="confirm()">
              Confirmar
            </v-btn>
          </v-card-actions>
        </v-card>
      </ValidationObserver>
    </v-dialog>
  </div>
</template>
<script>
import { required } from 'vee-validate/dist/rules';
import {
  extend, ValidationObserver, ValidationProvider, setInteractionMode,
} from 'vee-validate';

setInteractionMode('eager');

extend('required', {
  ...required,
  message: '{_field_} não pode ser vazio',
});

export default {
  name: 'DialogNewSortValue',
  components: {
    ValidationProvider,
    ValidationObserver,
  },

  props: {
    open: Boolean,
    selectedItemSort: {},
  },

  data: () => ({
    newSortValue: 0,
  }),

  watch: {
    selectedItemSort() {
      this.newSortValue = this.selectedItemSort.sort;
    },
  },

  methods: {
    cancel() {
      this.$refs.observer.reset();
      this.$emit('closeNewSortValue');
    },

    confirm() {
      this.$refs.observer.validate().then((result) => {
        if (result) {
          this.$emit('confirmNewSortValue', this.selectedItemSort, this.newSortValue);
          this.$refs.observer.reset();
        }
      });
    },

  },
};
</script>
